// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"ImageBlocksSection_r-mobile__bJ_2V","r-not-mobile":"ImageBlocksSection_r-not-mobile__e3ZzV","container":"ImageBlocksSection_container__6Q0eE"};